module.exports = __webpack_public_path__ + "_assets/img/Frame1198.2e074dcd.svg";